/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirmdowngrade1Inputs */

const en_confirmdowngrade1 = /** @type {(inputs: Confirmdowngrade1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm plan change`)
};

const de_confirmdowngrade1 = /** @type {(inputs: Confirmdowngrade1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wechsel bestätigen`)
};

/**
* | output |
* | --- |
* | "Confirm plan change" |
*
* @param {Confirmdowngrade1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const confirmdowngrade1 = /** @type {((inputs?: Confirmdowngrade1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirmdowngrade1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirmdowngrade1(inputs)
	return de_confirmdowngrade1(inputs)
});
export { confirmdowngrade1 as "confirmDowngrade" }